module.exports = __webpack_public_path__ + "static/kaleekarma-15d61d738fa21e7930487ab2c4956525.jpg";